import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import html2canvas from "html2canvas";

import {
  adjustBorderHeight,
  getQrCodeInfo,
  noInternetResponse,
  showToastMessage
} from "../../common/common";
import { getModelProfileData } from "../../data-services/edit-profile";
import { Network } from "@capacitor/network";
import axios from "axios";



const QR9KoalaStep2SuccessFollow: React.FC = () => {
  const history = useHistory();
  const photoContainerRef = useRef<HTMLDivElement>(null);

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(670);
  }, []);

  const trackCTAClick = async () => {
    const options: any = {
      method: "post",
      url: `${process.env.REACT_APP_HP_API_URL}/users/registerConsumerCTA`,
      data: {
        uuid: localStorage.getItem('uuid'),
        ctaType: "cta1",
        ctaLabel: 'Koala follow on Instagram button pressed'
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    await axios(options);
    window.location.href = 'https://www.instagram.com/koalaeco/'
  }

  return (
    <IonPage>

      <IonContent className={`lay__container--${qrDetails?.eventQrId}`}>
        <div className="lay__background">
          <img src="/images/cons/qr9koala/Background.png" />
        </div>

        <div className="lay__background lay__background--border">
          <img src="/images/cons/qr9koala/Border.png" />
        </div>

        {typeof qrDetails != 'undefined' && 
          <div className={`lay__content--${qrDetails?.eventQrId}`}>

            <div className="img__first" style={{marginTop: '100px', marginBottom: '50px'}}>
              <div className="talent-signup__section-title talent-signup__section-title--smaller2">
                <img src="/images/cons/qr9koala/p3-img1.png" />
              </div>
            </div>

            <div className="img__inline" style={{marginTop: '0px', zIndex: 3, width: '150px'}}>
              <div onClick={trackCTAClick} style={{cursor: 'pointer'}}>
                <img src="/images/cons/qr9koala/p3-CTA.png" />
              </div>
            </div>

          </div>}
      </IonContent>

    </IonPage>
  );
};

export default QR9KoalaStep2SuccessFollow;
